import { useEffect, useState } from 'react';

/**
 * Mini Prixia (X3): ¿hay un diálogo abierto? Radix (Dialog, Sheet, AlertDialog,
 * Popover) y el modal de «¿Cómo funciona?» de Inferencia llevan `role`; el tooltip
 * del recorrido no. Con uno abierto el recorrido se pausa: no lo tapa.
 */
const SELECTOR_DE_DIALOGO =
  '[role="dialog"]:not([data-state="closed"]), [role="alertdialog"]:not([data-state="closed"])';

export function hayDialogoAbierto(): boolean {
  return document.querySelector(SELECTOR_DE_DIALOGO) !== null;
}

export function useHayDialogoAbierto(activo: boolean): boolean {
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    if (!activo) {
      setAbierto(false);
      return;
    }
    const medir = () => setAbierto(hayDialogoAbierto());
    medir();
    const observador = new MutationObserver(medir);
    observador.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state', 'role'],
    });
    return () => observador.disconnect();
  }, [activo]);

  return abierto;
}
